import { render, staticRenderFns } from "./BagshTailbarBichih.vue?vue&type=template&id=29b273ec"
import script from "./BagshTailbarBichih.vue?vue&type=script&lang=js"
export * from "./BagshTailbarBichih.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports